import React from 'react'

import { Combobox } from '../common/components/combobox'
import { AVAILABLE_LANGUAGES, useLocalizationContext } from '../common/components/localization-provider'

const transformLanguageToOption = (language: string) => ({ value: language, label: language.toUpperCase() })

export type LanguageSelectProps = {
    styles: {
        singleValue?: React.CSSProperties
        menu?: React.CSSProperties
        dropdownIndicator?: React.CSSProperties
    }
    onChange?: (language: string) => void
    asWidget?: boolean
}

const LanguageSelect = ({ onChange }: LanguageSelectProps): React.ReactElement => {
    const { locale, setLocale } = useLocalizationContext()

    console.error('locale', locale)
    return (
        <Combobox
            id="select-language"
            value={locale}
            enableDefaultOption={false}
            data-testid={`${locale}-language`}
            options={AVAILABLE_LANGUAGES.map((language) => transformLanguageToOption(language))}
            onChange={(option) => {
                if (option?.value) {
                    onChange && onChange(option?.value)

                    setLocale(option?.value)
                }
            }}
        />
    )
}

export default LanguageSelect
